import React from "react";
import { Button, Col, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import {
  CustomerSearchCriteria,
  MultiplePickTicketSearchCriteria,
  PageListBean,
  RestCustomerListRequest,
  RestPageListBean,
  RestReadRequest,
  RestSalesOrderListRequest,
  SalesOrderSearchCriteria,
} from "../ds/ds.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DataGridColumnDefinition,
  DatePickerComponent,
  EditableDataGrid,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { SalesOrderLookupHandler } from "../lookup/SalesOrderLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupPickTicketModule,
  PopupSalesModule,
} from "../modules/ModuleUtil.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { InvoiceService } from "../services/InvoiceService.js";
import { SalesOrderService } from "../services/SalesOrderService.js";
import CustomTable from "../gui_components/CustomTable.js";

class InvoiceForMultiplePickTicket extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Invoice For Multiple PickTickets",
      isShowExitButton: true,
      isShowExecuteButton: true,
      isShowInvoiceButton: false,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      criteria: new MultiplePickTicketSearchCriteria(),
      inquiryDataList: [],
      isInquiryDatasFound: false,
      isDisableFields: false,
      isShowLookUp: true,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      salesPageListForAutoCompleteList: new Array(),
      showAutoCompleteSalesOrderList: true,
      selectedRowDataList: [],
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      moduleForPopup: [],
      isShowCustomerModule: false,
      isShowSalesOrderMaintenanceModule: false,
      isShowPickTicketModule: false,
      error_list: [],
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
    };
    this.customerCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    ModuleUtils.getPickTicketStatusList();
    this.initLookupHandlers();
  }
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "customerCode"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });

    let salesOrderLookupHandler = new SalesOrderLookupHandler(
      this.companyCode,
      "salesOrderNumber"
    );
    this.setState({ salesOrderLookupHandler: salesOrderLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  loadPage = () => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    if (
      !isEmptyString(criteria.customerCode) ||
      !isEmptyString(criteria.salesOrderNumber)
    ) {
      this.loadPickticketList(criteria);
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Executing ...",
      });
    } else {
      let errMsg = "Customer/SalesOrderNumber Required";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadPickticketList = (listRequest) => {
    if (SecurityAccessManager.InvoiceForMultiplePickticketView_IsAccessible()) {
      InvoiceService.getMultiplePickedPickTicket(
        listRequest,
        this.loadPickTicketPageResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadPickTicketPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null) {
      let resultList = new Array();
      if (!isEmptyArray(response.data.result.invoicesInfoList)) {
        resultList = response.data.result.invoicesInfoList;
      }
      this.setState({
        isInquiryDatasFound: true,
        inquiryDataList: resultList,
        isShowInvoiceButton: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        isShowLookUp: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    ShowError("Error : ", error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  clearCriteria = () => {
    let criteria = new MultiplePickTicketSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    this.setState({
      criteria: criteria,
    });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new MultiplePickTicketSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowInvoiceButton: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
      isShowLookUp: true,
    });
    this.hideAlertCallBack();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerName = "";
      criteria.customerCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.loadCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  loadCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  loadCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.loadCustomerDetailResponse,
      this.errorCallBack
    );
  };
  loadCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 10;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.loadCustomerCodeResponse,
      this.errorCallBack
    );
  }
  loadCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.loadCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  onSalesOrderChange = (e) => {
    let salesOrder = e.target.value;
    this.state.showAutoCompleteSalesOrderList = true;
    let criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteSalesOrderList;
    if (isEmpty(salesOrder)) {
      this.state.showAutoCompleteSalesOrderList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesOrderList;
      let criteria = this.state.criteria;
      criteria.salesOrderNumber = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteSalesOrderList: showAutoCompleteList,
        criteria: criteria,
        salesPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "salesOrderNumber" &&
      showAutoCompleteList === true &&
      salesOrder !== ""
    ) {
      this.loadSalesBySearchString(e.target.value);
    }
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
    this.loadSalesOrderDetail(salesOrder);
  };
  loadSalesOrderDetail = (salesOrder) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = salesOrder;
    readrestInput.isLockRequired = true;
    SalesOrderService.initSalesOrderModule(
      readrestInput,
      this.loadSalesOrderResponse,
      this.errorCallBack
    );
  };
  loadSalesOrderResponse = (response) => {
    if (
      response.data.salesOrderResponse != null &&
      response.data.salesOrderResponse.salesOrder != null
    ) {
      let criteria = this.state.criteria;
      const salesOrder = response.data.salesOrderResponse.salesOrder;
      criteria.salesOrderNumber = salesOrder.code;
      let showAutoCompleteSalesOrderList = false;
      this.setState({
        criteria: criteria,
        showAutoCompleteSalesOrderList: showAutoCompleteSalesOrderList,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  loadSalesBySearchString(searchString) {
    let searchCriteria = new SalesOrderSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.salesOrderNumberStartsWith = searchString;
    searchCriteria.salesOrderNumberContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestSalesOrderListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    SalesOrderService.getSalesOrderPageList(
      input,
      this.loadBySalesOrderResponse,
      this.errorCallBack
    );
  }
  loadBySalesOrderResponse = (response) => {
    let salesData = response.data.salesOrderPageList.salesOrders;
    let simpleAutoCompleteList = new Array();
    if (salesData.length > 0 && salesData != null) {
      salesData.map((salesCode) => {
        let simpleItemBean = {
          code: salesCode.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      salesPageListForAutoCompleteList: simpleAutoCompleteList,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  salesCodeEnterKeyEventHandler = (e) => {
    let salesCode = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading... ",
    });
    this.loadSalesOrderDetail(salesCode);
    this.setState({
      salesPageListForAutoCompleteList: new Array(),
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  displayAutoCompleteSalesList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteSalesOrderList: showAutoCompleteList });
  };
  invoice = (e) => {
    if (e.detail == 1) {
      let criteria = this.state.criteria;
      criteria.companyCode = this.companyCode;
      let selectedLine = this.state.selectedRowDataList;
      let pickTicketNumber = [];
      selectedLine.map((p) => {
        pickTicketNumber.push(p.pickTicketNumber);
      });
      criteria.pickTicketNumber = pickTicketNumber;
      if (!isEmptyArray(criteria.pickTicketNumber)) {
        this.loadInvoiceList(criteria);
        this.setState({
          isShowProgressBarPopup: true,
          progressLoadingText: "Invoice Generation",
        });
      } else {
        let errMsg = "No Invoice Selected";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadInvoiceList = (listRequest) => {
    if (
      SecurityAccessManager.InvoiceForMultiplePickticketCreate_IsAccessible()
    ) {
      InvoiceService.createInvoiceForMultiplePickTicket(
        listRequest,
        this.loadCreateInvoicePageResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadCreateInvoicePageResponse = (response) => {
    this.showErrorMessage(response.data);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    if (response.data.infos != null && !isEmptyArray(response.data.invoice)) {
      this.showInfoMessage(response.data);
      this.setState({
        selectedRowDataList: [],
      });
      this.loadPage(1);
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerModule: isOpen,
      isShowSalesOrderMaintenanceModule: isOpen,
      isShowPickTicketModule: isOpen,
      moduleForPopup: [],
    });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewCustomerModule = (e,code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowCustomerModule: true,
        moduleForPopup: (
          <PopupCustomerModule
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewsalesOrderModule = (e,code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowSalesOrderMaintenanceModule: true,
        moduleForPopup: (
          <PopupSalesModule code={code} onModuleExit={this.onPopupModalExit} />
        ),
      });
    }
  };
  viewPickTicketModule = (e,code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowPickTicketModule: true,
        loadingText: "Executing",
        moduleForPopup: (
          <PopupPickTicketModule
            pickTicketCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  selectAll = (e) => {
    let list = this.state.inquiryDataList;
    list.map((line, i) => {
      line.isApplied = true;
    });
    this.setState({ selectedRowDataList: list });
  };
  unSelectAll = (e) => {
    let list = this.state.inquiryDataList;
    list.map((line, i) => {
      line.isApplied = false;
    });
    this.setState({ selectedRowDataList: [] });
  };
  onSelectedChange = (e, rowData) => {
    rowData.isApplied = e.target.value;
    if (rowData.isApplied === true) {
      let selectedLine = this.state.selectedRowDataList;
      selectedLine.push(rowData);
      this.setState({ selectedRowDataList: selectedLine });
    } else {
      let checkLines = this.state.selectedRowDataList;
      let selectedLine = [];
      for (let line of checkLines) {
        if (line.isApplied != rowData.isApplied) {
          selectedLine.push(line);
          this.setState({ selectedRowDataList: selectedLine });
        } else if (this.state.selectedRowDataList.length == 1) {
          this.setState({ selectedRowDataList: [] });
        }
      }
    }
  };
  getCaption = (status)=>{
    return ModuleUtils.getPickTicketStatusCaption(status)
  }
  invoiceColumns = ()=>{
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("",  "isApplied", true)
        .setStyleDetails("left","","","wt-2","wt-2")   
        .setInputDetails(false, false, true, null, this.onSelectedChange,null) 
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Customer",  "customerCode", true)
        .setStyleDetails("left","","","wt-2","wt-2")   
        .setClickDetails(true,false,this.viewCustomerModule,null)
    );
  
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer Name",  "customerName", true)   
        .setStyleDetails("left","","","wt-3","wt-3")   
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Sales Order",  "salesOrderNumber", true)
        .setStyleDetails("left","","","wt-2","wt-2")   
        .setClickDetails(true,false,this.viewsalesOrderModule,null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PickTicket",  "pickTicketNumber", true)
        .setStyleDetails("left","","","wt-2","wt-2")   
        .setClickDetails(true,false,this.viewPickTicketModule,null)
    );
   
    columns.push(
      new ColumnDefinition()
      .setDetails("Status",  "status", true)
      .setStyleDetails("left", "", "", "wt-2", "wt-2")
      .setStatusDetails(true,this.getCaption)
       
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Created Date",  "pickTicketDate", true)
        .setStyleDetails("left","","","wt-3","wt-3")   
    );
  
return columns;
  
  }
  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails("", "isApplied", 0, false, null, false, null, "2em", "8%")
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.onSelectedChange
        )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Customer",
        "customerCode",
        0,
        true,
        this.viewCustomerModule
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Customer Name", "customerName")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Sales Order",
        "salesOrderNumber",
        0,
        true,
        this.viewsalesOrderModule
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "PickTicket",
        "pickTicketNumber",
        0,
        true,
        this.viewPickTicketModule
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Status",
        "status",
        0,
        false,
        null,
        false,
        null,
        false,
        false,
        true,
        ModuleUtils.getPickTicketStatusCaption
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Created Date",
        "pickTicketDate"
      )
    );
    return columnList;
  };

  render() {
    let inquiryDataList = this.state.inquiryDataList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExitButton={this.state.isShowExitButton}
          isShowInvoiceButton={this.state.isShowInvoiceButton}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowResetButton={this.state.isShowResetButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          reset={this.resetInquiry}
          extend_toolbar={
            <>
              {this.state.isShowInvoiceButton && (
                <Button
                  className="header_buttons secondary"
                  size="sm"
                  onClick={(e) => this.invoice(e)}
                >
                  Invoice
                </Button>
              )}
            </>
          }
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          customerCodeOnChange={this.customerCodeOnChange}
          customerCodeRef={this.customerCodeRef}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
          onSalesOrderChange={this.onSalesOrderChange}
          salesCodeEnterKeyEventHandler={this.salesCodeEnterKeyEventHandler}
          displayAutoCompleteSalesList={this.displayAutoCompleteSalesList}
        />
        <div>
          {this.state.isInquiryDatasFound ? (
            <div className="div_default">
              {/* <EditableDataGrid
                columnsList={this.columnDefinitions()}
                dataList={inquiryDataList}
              /> */}
              <CustomTable
 columns={this.invoiceColumns()}
 data={inquiryDataList}
 label={"Pickticket List"}
              />
            </div>
          ) : null}
        </div>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowCustomerModule}
          popupLvlClass={"popupSizeLeve11"}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowSalesOrderMaintenanceModule}
          popupLvlClass={"popupSizeLeve11"}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowPickTicketModule}
          popupLvlClass={"popupSizeLeve11"}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  let criteria = props.criteria;
  const customerCodeRef = props.customerCodeRef;
  const onChange = (e) => props.onChange(e);
  let salesOrderRef = React.createRef();
  const customerCodeOnChange = (e) => props.customerCodeOnChange(e);
  const onSalesOrderChange = (e) => props.onSalesOrderChange(e);
  const customerCodeEnterKeyEventHandler = (e) => {
    props.customerCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteList = () => {
    props.displayAutoCompleteList();
  };
  const salesCodeEnterKeyEventHandler = (e) => {
    props.salesCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteSalesList = () => {
    props.displayAutoCompleteSalesList();
  };
  return (
    <div>
      <Row className="d-flex justify-context-left">
        <Col sm="1">
          <FormLabel>Customer</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={customerCodeRef}
            name="customerCode"
            placeholder="Customer"
            onChange={customerCodeOnChange}
            value={criteria.customerCode}
            lookupRequired={props.isShowLookUp}
            showCriteriaDialog={true}
            lookupHandler={props.customerLookupHandler}
            enterKeyEventHandler={customerCodeEnterKeyEventHandler}
            autoCompleteListData={props.customerPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteList}
            showAutoCompleteList={props.showAutoCompleteCustomerList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="3">
          <InputTextbox
            disabled={true}
            name="customerName"
            placeholder="Customer Name"
            onChange={onChange}
            value={criteria.customerName}
          />
        </Col>
        <Col sm="1">
          <FormLabel>From Date</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent
            name="fromPickedDate"
            value={criteria.fromPickedDate}
            onChange={onChange}
            disabled={props.isDisableFields}
          />
        </Col>
        <Col sm="1">
          <FormLabel> To Date</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent
            name="toPickedDate"
            value={criteria.toPickedDate}
            onChange={onChange}
            disabled={props.isDisableFields}
          />
        </Col>
      </Row>
      <Row>
        <Col sm="1">
          <FormLabel> SaleOrder Number </FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            onChange={onSalesOrderChange}
            name="salesOrderNumber"
            ref={salesOrderRef}
            lookupRequired={props.isShowLookUp}
            lookupHandler={props.salesOrderLookupHandler}
            value={criteria.salesOrderNumber}
            showCriteriaDialog={true}
            enterKeyEventHandler={salesCodeEnterKeyEventHandler}
            autoCompleteListData={props.salesPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteSalesList}
            showAutoCompleteList={props.showAutoCompleteSalesOrderList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
      </Row>
    </div>
  );
}
function InvoiceForMultiplePickTicketModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <InvoiceForMultiplePickTicket {...props} name="" /> <br />
      </div>
    </div>
  );
}
export default InvoiceForMultiplePickTicketModule;
